var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'flex items-center px-16 py-8 text-white font-bold rounded-6 gap-8 cursor-pointer w-max select-none',
    _vm.toggled ? 'bg-anyvan-blue-dark' : 'bg-blue-primary hover:bg-secondary'
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default"),_vm._v(" "),(_vm.chevron)?_c('img',{class:[_vm.$style.chevron, _vm.toggled ? _vm.$style.up : _vm.$style.down],attrs:{"src":"/content-static/navigation-menu/chevron-down.svg","alt":"chevron down","loading":"lazy"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }